import type { GetCourses200CoursesItemInstructorBasicInfo } from './getCourses200CoursesItemInstructorBasicInfo';
import type { GetCourses200CoursesItemInstructorSocial } from './getCourses200CoursesItemInstructorSocial';

/**
 * 강사 정보
 */
export type GetCourses200CoursesItemInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: GetCourses200CoursesItemInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetCourses200CoursesItemInstructorSocial;
};
